import { computed } from "vue";
import { useImage } from "@vueuse/core";
import ImgSkeleton from "../assets/product-skeleton.png";
import ImgEmpty from "../assets/product-empty.png";

export default (src?: string) => {
  const { isLoading: isLoadingImage, error: errorImage } = useImage({
    src: src || "",
  });
  const imageSrc = computed(() =>
    isLoadingImage.value ? ImgSkeleton : errorImage.value ? ImgEmpty : src,
  );

  return { imageSrc };
};
